import { isAnyOf } from "@reduxjs/toolkit";

import { cleanUpCollectionPointDetail } from "../../reducers/collectionPointReducer";
import {
  cleanUpCollectionYardsVisitsDetail,
  getCollectionYardsVisitsDetailThunk,
  removeCollectionYardsVisitsDetailFilter,
  setCollectionYardsVisitsDetailFilter,
  setCollectionYardsVisitsDetailOrdering,
  setCollectionYardsVisitsDetailPagination,
  setCollectionYardsVisitsDetailSearch,
} from "../../reducers/collectionYardsVisitsDetailReducer";
import { COLLECTION_POINT_PAGE_PATH } from "../routes";
import { startAppListening } from "./listenerMiddleware";
import { resetCollectionYardsVisitsDetail } from "./utils/resetCollectionYardsVisitsDetail";

export const collectionYardsVisitsDetailListener = (): void => {
  startAppListening({
    matcher: isAnyOf(
      setCollectionYardsVisitsDetailOrdering,
      setCollectionYardsVisitsDetailSearch,
      setCollectionYardsVisitsDetailFilter,
      removeCollectionYardsVisitsDetailFilter
    ),
    effect: async (_, { dispatch }) => {
      const pathname = location.pathname;
      switch (pathname) {
        case COLLECTION_POINT_PAGE_PATH:
          resetCollectionYardsVisitsDetail(dispatch);
          break;

        default:
          break;
      }
    },
  });

  startAppListening({
    actionCreator: setCollectionYardsVisitsDetailPagination,
    effect: async (_, { dispatch, getState }) => {
      const state = getState();
      const locationId = state.collectionPoint.collectionPoint.locationId;

      dispatch(getCollectionYardsVisitsDetailThunk(locationId));
    },
  });

  startAppListening({
    actionCreator: cleanUpCollectionPointDetail,
    effect: async (_, { dispatch }) => {
      dispatch(cleanUpCollectionYardsVisitsDetail());
    },
  });
};
